import * as Types from '../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeviceSecretQueryVariables = Types.Exact<{
  input: Types.DeviceSecretInput;
}>;


export type DeviceSecretQuery = { readonly __typename?: 'Query', readonly deviceSecret: { readonly __typename?: 'DeviceSecret', readonly value: string } };


export const DeviceSecretDocument = gql`
    query DeviceSecret($input: DeviceSecretInput!) {
  deviceSecret(input: $input) {
    value
  }
}
    `;

/**
 * __useDeviceSecretQuery__
 *
 * To run a query within a React component, call `useDeviceSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceSecretQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeviceSecretQuery(baseOptions: Apollo.QueryHookOptions<DeviceSecretQuery, DeviceSecretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceSecretQuery, DeviceSecretQueryVariables>(DeviceSecretDocument, options);
      }
export function useDeviceSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceSecretQuery, DeviceSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceSecretQuery, DeviceSecretQueryVariables>(DeviceSecretDocument, options);
        }
export type DeviceSecretQueryHookResult = ReturnType<typeof useDeviceSecretQuery>;
export type DeviceSecretLazyQueryHookResult = ReturnType<typeof useDeviceSecretLazyQuery>;
export type DeviceSecretQueryResult = Apollo.QueryResult<DeviceSecretQuery, DeviceSecretQueryVariables>;